import { useEffect } from "react"

// wont throw linting errors for missing/unused dependencies
export const useEffectUnsafe = (effect: React.EffectCallback, deps?: React.DependencyList) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, deps)
}
